import { render, staticRenderFns } from "./SamBreadcrumbs.vue?vue&type=template&id=11edf7bc&scoped=true&shadow"
import script from "./SamBreadcrumbs.vue?vue&type=script&lang=js&shadow"
export * from "./SamBreadcrumbs.vue?vue&type=script&lang=js&shadow"
function injectStyles (context) {
  
  var style0 = require("./SamBreadcrumbs.vue?vue&type=style&index=0&id=11edf7bc&prod&lang=scss&scoped=true&shadow")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "11edf7bc",
  null
  ,true
)

export default component.exports